// API client — Pricing mandat (Lot M3).
const BASE = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const { method = "GET", body } = opts;
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const d = data?.detail;
    const code = typeof d === "object" ? d?.code : undefined;
    const msg = code || (typeof d === "string" ? d : `HTTP ${res.status}`);
    const err = new Error(msg);
    err.status = res.status;
    err.code = code;
    err.detail = d;
    throw err;
  }
  return data;
}

export const mandatePricing = {
  initialize: (mandateId, { currency = "EUR", asking_price, net_seller }) =>
    req(`/api/mandates/${mandateId}/pricing/initialize`, {
      method: "POST",
      body: { currency, asking_price: Number(asking_price),
              net_seller: Number(net_seller) },
    }),
  patchAskingPrice: (mandateId, { value, reason }) =>
    req(`/api/mandates/${mandateId}/pricing/asking-price`, {
      method: "PATCH",
      body: { value: Number(value), reason },
    }),
  get: (mandateId) =>
    req(`/api/mandates/${mandateId}/pricing`),
  history: (mandateId) =>
    req(`/api/mandates/${mandateId}/pricing/history`),
};

export default mandatePricing;
